/**
 * フロントエンドJSエラー捕捉 + API送信
 * - 全エラーをAPIに投げる（フィルタはサーバー側）
 * - クライアント側レート制限のみ実施
 */
(function () {
    var API_URL = '/api/v1/client-error';
    var DEDUP_INTERVAL = 5 * 60 * 1000; // 同一エラー5分再送なし
    var RATE_LIMIT = 10;                 // 全体1分10件
    var RATE_WINDOW = 60 * 1000;

    var recentErrors = {};  // key -> timestamp
    var sendTimestamps = []; // 全送信タイムスタンプ

    function _isRateLimited(key) {
        var now = Date.now();

        // 同一エラー重複チェック
        if (key && recentErrors[key] && (now - recentErrors[key]) < DEDUP_INTERVAL) {
            return true;
        }

        // 全体レート制限
        sendTimestamps = sendTimestamps.filter(function (t) { return (now - t) < RATE_WINDOW; });
        if (sendTimestamps.length >= RATE_LIMIT) {
            return true;
        }

        return false;
    }

    function _recordSend(key) {
        var now = Date.now();
        if (key) recentErrors[key] = now;
        sendTimestamps.push(now);
    }

    function _sendError(data) {
        var key = data.type + ':' + (data.message || '') + ':' + (data.line || '');

        if (_isRateLimited(key)) return;
        _recordSend(key);

        data.page_url = location.href;
        data.user_id = window.VL_USER_ID || 0;
        data.actor_id = window.VL_ACTOR_ID || 0;
        data.user_agent = navigator.userAgent;

        try {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', API_URL, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('X-CSRF-TOKEN', document.querySelector('meta[name="csrf-token"]')?.content || '');
            xhr.send(JSON.stringify(data));
        } catch (e) {
            // 送信失敗は無視
        }
    }

    // 1. window.onerror - 未キャッチのJSエラー
    var _origOnError = window.onerror;
    window.onerror = function (message, url, line, column, error) {
        _sendError({
            type: 'onerror',
            message: String(message),
            url: url || '',
            line: line || 0,
            column: column || 0,
            stack: error && error.stack ? error.stack : ''
        });
        if (_origOnError) return _origOnError.apply(this, arguments);
    };

    // 2. unhandledrejection - 未処理のPromiseエラー
    window.addEventListener('unhandledrejection', function (event) {
        var reason = event.reason;
        var message = '';
        var stack = '';

        if (reason instanceof Error) {
            message = reason.message;
            stack = reason.stack || '';
        } else if (typeof reason === 'string') {
            message = reason;
        } else {
            try { message = JSON.stringify(reason); } catch (e) { message = String(reason); }
        }

        _sendError({
            type: 'unhandledrejection',
            message: message,
            url: '',
            line: 0,
            column: 0,
            stack: stack
        });
    });

    // 3. 手動報告 - try/catch で握った失敗など、 自動捕捉に乗らないものを送る
    //    （ 配信画面の getUserMedia 失敗など ）。 レート制限は自動報告と共通。
    window.VLReportError = function (type, message, stack) {
        if (!type || !message) return;
        _sendError({ type: String(type).slice(0, 50), message: String(message).slice(0, 2000), stack: stack ? String(stack).slice(0, 5000) : null });
    };

    // 4. Vue errorHandler - グローバル関数として公開
    window.VLReportVueError = function (err, instance, info) {
        _sendError({
            type: 'vue',
            message: err && err.message ? err.message : String(err),
            url: '',
            line: 0,
            column: 0,
            stack: err && err.stack ? err.stack : ''
        });

        // デフォルト動作: ラップ前のconsole.errorで出力（二重送信回避）
        if (typeof _origConsoleError === 'function') {
            _origConsoleError.call(console, err);
        }
    };

    // 5. console.error ラップ - catchされたエラーの捕捉
    var _origConsoleError = console.error;
    console.error = function () {
        var args = Array.prototype.slice.call(arguments);
        var message = '';
        var stack = '';

        for (var i = 0; i < args.length; i++) {
            if (args[i] instanceof Error) {
                message = args[i].message;
                stack = args[i].stack || '';
                break;
            }
        }

        if (!message) {
            message = args.map(function (a) {
                if (typeof a === 'string') return a;
                try { return JSON.stringify(a); } catch (e) { return String(a); }
            }).join(' ');
        }

        _sendError({
            type: 'console.error',
            message: message,
            url: '',
            line: 0,
            column: 0,
            stack: stack
        });

        return _origConsoleError.apply(console, arguments);
    };
})();
